<script>
export default {
  name: "GlobalBanner",
  props: {
    banner: {
      type: Object,
      required: true
    },
    renderedText: {
      type: String,
      required: true
    }
  },
  methods: {
    getClassesForIcon(icon) {
      let classes = {
        "fas": true,
        "fa-spin": icon.spin,
        "fa-pulse": icon.spin_pulse,
        "fa-spin-reverse": icon.spin_revers,
        "fa-bounce": icon.bounce,
        "fa-beat": icon.beat,
        "fa-beat-fade": icon.beat_fade,
        "fa-fade": icon.fade,
        "fa-flip": icon.flip,
        "fa-shake": icon.shake,
        "fa-rotate": icon.rotate
      };

      classes[icon.icon_name] = true;

      return classes;
    }
  },
  computed: {
    backgroundColor() {
      return this.banner.story.content.background_color.color;
    },
    hasIconsAfter() {
      return this.banner.story.content.icons_after.length > 0;
    },
    hasIconsBefore() {
      return this.banner.story.content.icons_before.length > 0;
    },
    styles() {
      return {
        color: this.banner.story.content.icon_and_text_color.color
      }
    }
  }
}
</script>

<template>
  <div
      v-if="banner.story.content.active"
      class="container-fluid py-1"
      :style="{ backgroundColor: backgroundColor }"
  >
    <div class="d-flex justify-content-center align-items-center container">
      <span v-if="hasIconsBefore" class="mr-3 icon-group">
        <i
            v-for="icon in banner.story.content.icons_before"
            :class="getClassesForIcon(icon)"
            :style="styles"
        ></i>
      </span>
      <div class="text-content mx-3" v-html="renderedText" :style="styles"></div>
      <span v-if="hasIconsAfter" class="ml-3 icon-group">
        <i
            v-for="icon in banner.story.content.icons_after"
            :class="getClassesForIcon(icon)"
            :style="styles"
        ></i>
      </span>
    </div>
  </div>
</template>

<style>
.icon-group > i {
  padding-left: 2.5px;
  padding-right: 2.5px;
}

.text-content > p {
  margin-bottom: 0 !important;
}
</style>
